import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { defineMessages, useIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { AccountContext } from '../../../components/AccountContext';
import useSubscriptionExpiredRestrictions from '../../../hooks/useSubscriptionExpiredRestrictions';

import { parse, stringify } from '../../../utils/UrlUtil';

const messages = defineMessages({
  import: { id: 'actions.import', defaultMessage: 'Import' },
});

const RespondentImportListHeader = () => {
  const currentAccount = useContext(AccountContext);
  const history = useHistory();
  const location = useLocation();
  const params = parse(location.search);
  const { formatMessage } = useIntl();
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  const [filter, setFilter] = useState({ ...params.filter });

  /**
   * Get old URL and:
   * - parse query params
   * - merge new param values
   * - stringify query params
   * - push new url
   */
  const onQueryVariableChange = () => {
    const params = parse(location.search);

    // build the filter
    const newFilter = {
      ...params.filter,
      ...filter,
    };

    const search = stringify({
      ...params,
      filter: newFilter,
    });

    // update url with the new search, keep the rest of the values
    history.push({
      ...location,
      search,
    });
  };

  /**
   * Update the filter Query.
   */
  const onChangeQueryText = (event) => {
    const updatedFilter = {
      ...filter,
      query: event.currentTarget.value,
    };

    setFilter(updatedFilter);
  };

  return (
    <div className="p-grid">
      <div className="p-sm-6">
        <div className="p-inputgroup">
          <InputText
            value={filter.query}
            onChange={onChangeQueryText}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                onQueryVariableChange();
              }
            }}
          />
          <Button icon="pi pi-search" onClick={onQueryVariableChange} />
        </div>
      </div>
      <div className="p-sm-6 align-right">
        <Button
          icon="pi pi-plus"
          label={formatMessage(messages.import)}
          disabled={subscriptionIsExpired}
          onClick={() => history.push(`/accounts/${currentAccount}/respondents/imports/new`)}
        />
      </div>
    </div>
  );
};

export default RespondentImportListHeader;
